import { Label } from "./styles";

type Props = {
  value: boolean;
  setValue: (value: boolean) => void;
  disabled?: boolean;
  onClick?: () => void;
  /** What it turns on and off, for screen readers (usually the title shown beside it). */
  label?: string;
};

const ToggleSwitch = ({ value, setValue, disabled = false, onClick, label }: Props) => {
  const handleChange = () => {
    if (!disabled) {
      setValue(!value);
    }
  };

  const handleClick = () => {
    if (!disabled) {
      return;
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <Label onClick={handleClick}>
      <input
        type="checkbox"
        role="switch"
        aria-label={label}
        checked={value}
        onChange={handleChange}
        disabled={disabled}
      />
      <span></span>
    </Label>
  );
};

export default ToggleSwitch;
